export const data = [
  {
    title: "Ortodoncia Brackets",
    descripcion:"La ortodoncia es la rama de la odontología que se encarga de los problemas de los dientes y la mandíbula. La atención dental con ortodoncia incluye el uso de dispositivos, tales como los aparatos (Brackets), para: Enderezar los dientes.",
    imagen: "ortodoncia_brackets.jpg"
  },
  {
    title: "Implantologia Oral",
    descripcion:"La opción más estética, funcional y semejante a un diente natural, para remplazar uno o más dientes ausentes, cuando estos se han perdido por diversas causas. Un implante dental es un perno metálico que reemplaza la parte de la raíz de un diente faltante.",
    imagen: "implantes_dentales.jpg"
  },
  {
    title: "Odontologia Estética",
    descripcion:"La Estética Dental u odontología cosmética se fundamenta en dar belleza extra a los dientes. Un buen plan de odontología estética o Estética Dental permite corregir esos pequeños defectos de manera rápida y sin traumatismos.",
    imagen: "odontologia_estetica.jpg"  
  },
  {
    title: "Odontopediatría",
    descripcion:
      "La odontopediatría es la encargada del manejo de la salud dental de niños y adolescentes. En esta etapa podemos prevenir y diagnosticar de forma temprana alguna patología o alteración de maloclusión.",
    imagen: "odontopediatria.jpg",
  },
  {
    title: "Prótesis Fija (Corona o Puentes)",
    descripcion:
      "Tratamiento Rehabilitador que restaura la gran parte de la anatomía de la corona dental y va cementado Fijo a la raíz natural del Paciente, o atornillado o cementado a un Implante Dental. Corona o Prótesis Fija Unitaria, metal porcelana con o sin perno muñón. Puente o Prótesis Fija Plural.",
    imagen: "protesis_fija_coronas.jpg",
  },
  {
    title: "Periodoncia (Encías Sangrantes - Sarro)",
    descripcion:
    "La periodoncia aborda problemas de encías y tejidos dentales, incluyendo sangrado, placa, sarro, y encía inflamada. Puede resultar en pérdida de hueso y dientes en etapas avanzadas de la enfermedad.",
    imagen: "periodoncia_limpieza.jpg",
  },
  {
    title: "Ortodoncia Invisible",
    descripcion:
     "Es un tratamiento de ortodoncia invisible, donde se utilizan alineadores transparentes en reemplazo de los tradicionales brackets metálicos. Los alineadores son removibles y fabricados a la medida de cada paciente.",
    imagen: "ortodoncia_invisible.jpg",
  },
  {
    title: "Operatoria (Caries - Tapaduras Antiguas)",
    descripcion:
      "Operatoria Dental, es el área que se refiere a la eliminación de caries y cambio de restauraciones antiguas.",
    imagen: "caries.jpg",
  },
  {
    title: "Exodoncias Dentales en General",
    descripcion:
      "Exodoncia o extracción dental en general, adultos y niños.",
    imagen: "extracciones_dentales.jpg",
  },
  {
    title: "Plano de Relajación",
    descripcion:
      "Plano de Relajación o Plano de Alivio Oclusal, tratamiento para el bruxismo o apretar los dientes.",
    imagen: "plano_de_relajacion.jpg",
  },
  {
    title: "Blanqueamiento Dental",
    descripcion:
      "Blanqueamiento dental es un tratamiento con un agente químico que busca lograr un aclaramiento del color de los dientes. Existen muchos métodos para aplicar y activar el producto.",
    imagen: "blanqueamiento_dental.jpg",
  },
  {
    title: "Endodoncia (Tratamiento Conducto)",
    descripcion:
      "La endodoncia o tratamiento de conductos, es el procedimiento odontológico que se utiliza para eliminar la pulpa del diente y posteriormente sellarlo o rellenarlo con un material inerte.",
    imagen: "endodoncia.jpg",
  },
  {
    title: "Urgencias Dentales",
    descripcion:
      "Urgencias dentales, son toda problemática dental que surge en forma súbita e inesperada y necesita solución inmediata, como dolor, desalojo de restauración, fractura de un diente, etc.",
    imagen: "urgencia_dental.jpg",
  },
  {
    title: "Prótesis Removible Total",
    descripcion:
      "Prótesis Removible total es una alternativa para devolver la totalidad de los dientes perdidos en una arcada, por medio de un aparato removible. Esta prótesis puede ser convencional, es decir que se sujeta solo por una película de agua entre la prótesis y la mucosa o puede ser mucosoportado e implantoretenida con implantes dentales.",
    imagen: "protesis_removible_total.jpg",
  },
  {
    title: "PROTESIS REMOVIBLE PARCIAL",
    descripcion:
      "Prótesis Removible Parcial es una alternativa para devolver una cantidad de dientes perdidos, pero no la totalidad por arcada, por medio de un aparato removible, existen las de base acrílica (generalmente transitorias) o metálica (definitivas). Las Acrílicas también pueden ser inmediatas y/o cosméticas.",
    imagen: "protesis_removible_parcial.jpg",
  },
  {
    title: "Exodoncia Terceros Molares",
    descripcion:
    "La extracción de terceros molares, también conocidos como muelas del juicio, se realiza en el sillón dental con anestesia local y herramientas manuales si han erupcionado en la boca. Sin embargo, si están sumergidos en hueso, se requiere instrumental rotatorio para remover el tejido óseo que los cubre antes de extraerlos.",
    imagen: "extraccion_terceros_molares.jpg",
  },
  {
    title: "Prótesis Sobre Implantes",
    descripcion:
      "Corresponden a un amplio sistema de reposición de piezas dentales perdidas que van sujetados por implantes, pueden ser fijas o removibles. Las fijas son unitarias, plurales o totales.",
    imagen: "protesis_sobre_implantes.jpg",
  },
  {
    title: "Diagnóstico y prevención",
    descripcion:
      "Una evaluación general odontológica, es la forma más frecuente de prevenir, diagnosticar y tratar aquellos problemas primarios relacionados con los dientes, las encías o la lengua. En la mayoría de las ocasiones, las visitas de Odontología General son la primera toma de contacto con el dentista. Nuestra Evaluación es gratis.",
    imagen: "prevencion_diagnostico.jpg",
  },
];
